export enum InstitutionSort {
  Code = 1,
  Town = 2,
  Institution = 3,
  AdresaSjedista = 4,
  Program = 5,
}
